(function () {
  'use strict';

  var RUBBER_TYPES = ['rubber', 'rubbers'];
  var ASSEMBLY_KEYS = ['Assembly', 'Forehand Rubber', 'Backhand Rubber', 'Assembly Notes'];
  // Short suffixes used in the line item property keys that customers and
  // warehouse staff see in the cart and on order confirmations.
  // Produces: "P1 Assemble: Yes", "P1 FH: ...", "P1 BH: ...", "P1 Note: ..."
  var SHORT_SUFFIX = {
    'Assembly': 'Assemble',
    'Forehand Rubber': 'FH',
    'Backhand Rubber': 'BH',
    'Assembly Notes': 'Note'
  };
  function slotPropKey(slotIndex, assemblyKey) {
    return 'P' + slotIndex + ' ' + SHORT_SUFFIX[assemblyKey];
  }

  function isRubberType(t) { return RUBBER_TYPES.indexOf((t||'').toLowerCase().trim()) !== -1; }
  function isComboChild(item) {
    var p = item.properties||{};
    if (Array.isArray(p)) return p.some(function(x){ return x.name==='_combo_child'&&x.value==='true'; });
    return p['_combo_child'] === 'true';
  }
  function isBladeType(t) {
    var tl = (t||'').toLowerCase().trim();
    return tl.indexOf('blade') !== -1 && tl.indexOf('combo') === -1;
  }
  function rubberLabel(item) {
    var t=(item.title||'').trim(), v=(item.variant_title||'').trim();
    if (!v||v==='Default Title'||v==='Default') return t;
    if (t.toLowerCase().indexOf(v.toLowerCase())!==-1) return t;
    return t+' \u2014 '+v;
  }
  function getItemProp(item, key) {
    var p=item.properties||{};
    if (Array.isArray(p)){var f=p.find(function(x){return x.name===key;});return f?f.value:'';}
    return p[key]!==undefined?String(p[key]):'';
  }
  function fetchCart(){
    // cache: 'no-store' avoids any stale /cart.js response between save+fetch
    return fetch('/cart.js',{credentials:'same-origin', cache:'no-store'})
      .then(function(r){return r.json();});
  }

  // Parse a /cart/change.js response; surface useful error text when non-OK.
  function parseChangeResponse(r) {
    return r.text().then(function(text){
      var data = null;
      try { data = JSON.parse(text); } catch (_){ /* not JSON */ }
      if (!r.ok) {
        var msg = (data && (data.description || data.message)) || text || ('HTTP '+r.status);
        throw new Error('cart/change.js ' + r.status + ': ' + msg);
      }
      if (data && data.errors) throw new Error(JSON.stringify(data.errors));
      return data;
    });
  }

  // ─── Slot-aware property helpers ──────────────────────────────────────────
  // Properties are stored in the short "P1", "P1 FH", "P1 BH", "P1 Note" format.
  // For backward compatibility, we also read:
  //   - Older "Paddle N Assembly" / "Paddle N Forehand Rubber" format (pre-v135)
  //   - Legacy un-prefixed "Assembly" / "Forehand Rubber" (pre-multi-slot)
  //     — but only as a fallback for slot 1, since single-slot carts only
  //     covered one paddle.
  // All older formats get migrated to the short format on next save.
  function getSlotProp(blade, slotIndex, key) {
    var shortKey = slotPropKey(slotIndex, key);
    var val = getItemProp(blade, shortKey);
    if (val) return val;
    var longKey = 'Paddle ' + slotIndex + ' ' + key;
    val = getItemProp(blade, longKey);
    if (val) return val;
    if (slotIndex === 1) return getItemProp(blade, key);
    return '';
  }

  // Build a complete new properties object for this blade:
  //  - Preserves all non-assembly properties (any custom or future props)
  //  - Migrates legacy un-prefixed assembly keys → "P1" short format
  //  - Migrates older "Paddle N X" keys → "PN X" short format
  //  - Preserves other slots' short-format props untouched
  //  - Overwrites this slot's props with `slotUpdate`
  function buildMergedProps(blade, slotIndex, slotUpdate) {
    var result = {};
    var cp = blade.properties || {};
    if (Array.isArray(cp)) cp.forEach(function(p){ result[p.name] = p.value; });
    else Object.keys(cp).forEach(function(k){ result[k] = cp[k]; });

    // Migration pass 1: legacy un-prefixed → P1 short format (slot 1 ownership)
    ASSEMBLY_KEYS.forEach(function(k){
      if (result[k] !== undefined && result[k] !== '') {
        var shortKey = slotPropKey(1, k);
        if (result[shortKey] === undefined || result[shortKey] === '') {
          result[shortKey] = result[k];
        }
      }
      delete result[k];
    });

    // Migration pass 2: "Paddle N X" → "PN short" for all slots (up to blade qty)
    var bladeQty = parseInt(blade.quantity, 10) || 1;
    for (var s = 1; s <= bladeQty; s++) {
      ASSEMBLY_KEYS.forEach(function(k){
        var longKey = 'Paddle ' + s + ' ' + k;
        if (result[longKey] !== undefined && result[longKey] !== '') {
          var shortKey = slotPropKey(s, k);
          if (result[shortKey] === undefined || result[shortKey] === '') {
            result[shortKey] = result[longKey];
          }
        }
        delete result[longKey];
      });
    }

    // Orphan cleanup: drop any slot properties (either format) for slots
    // beyond the current quantity. Catches the case where a customer reduces
    // blade quantity after saving panels — the now-deleted paddle's saved
    // config should vanish from the line item.
    Object.keys(result).forEach(function(k){
      var m = k.match(/^(?:P|Paddle )(\d+)\s+/);
      if (m && parseInt(m[1], 10) > bladeQty) delete result[k];
    });

    // Apply updates for the current slot
    ASSEMBLY_KEYS.forEach(function(k){
      if (slotUpdate[k] === undefined) return;
      var shortKey = slotPropKey(slotIndex, k);
      if (slotUpdate[k]) result[shortKey] = slotUpdate[k];
      else delete result[shortKey];
    });

    // Validation marker read by the SupaEasy checkout validation function.
    // Present only when EVERY paddle slot (1..qty) has an Assemble answer
    // (Yes or No). Recomputed on every write, so it self-corrects when
    // quantity changes orphan a previously answered slot.
    var _allAnswered = true;
    for (var _vs = 1; _vs <= bladeQty; _vs++) {
      var _av = result[slotPropKey(_vs, 'Assembly')];
      if (_av === undefined || _av === null || _av === '') { _allAnswered = false; break; }
    }
    if (_allAnswered) result['_assembly_answered'] = 'true';
    else delete result['_assembly_answered'];

    return result;
  }

  // Save a single slot's assembly data, preserving all other props on the line.
  // Uses line number (1-indexed): Shopify docs note that `key` changes when
  // properties change and `id` (variant_id) is ambiguous if multiple lines
  // share a variant. Line numbers are stable for property-only changes.
  function saveSlotProps(bladeVariantId, slotIndex, slotUpdate) {
    return fetchCart().then(function(cart){
      var items = cart.items || [], blade = null, lineNum = -1, qty = 1;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (it.variant_id === bladeVariantId && isBladeType(it.product_type) && !isComboChild(it)) {
          blade = it; lineNum = i + 1; qty = parseInt(blade.quantity, 10) || 1; break;
        }
      }
      if (!blade) throw new Error('Blade variant ' + bladeVariantId + ' not found in cart');
      var merged = buildMergedProps(blade, slotIndex, slotUpdate);
      return fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({ line: lineNum, quantity: qty, properties: merged })
      }).then(parseChangeResponse)
        .then(function(data){ return { response: data, merged: merged }; });
    });
  }

  // Like saveSlotProps but also asks Shopify for rendered cart section HTML
  // and swaps it into the DOM in place. Used for background cleanup so the
  // displayed cart line item reflects corrected props without a full page reload.
  function saveSlotPropsAndRerender(bladeVariantId, slotIndex, slotUpdate) {
    return fetchCart().then(function(cart){
      var items = cart.items || [], blade = null, lineNum = -1, qty = 1;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (it.variant_id === bladeVariantId && isBladeType(it.product_type) && !isComboChild(it)) {
          blade = it; lineNum = i + 1; qty = parseInt(blade.quantity, 10) || 1; break;
        }
      }
      if (!blade) throw new Error('Blade variant ' + bladeVariantId + ' not found in cart');
      var merged = buildMergedProps(blade, slotIndex, slotUpdate);
      var mainCartItems = document.getElementById('main-cart-items');
      var sectionId = mainCartItems ? mainCartItems.dataset.id : null;
      var body = { line: lineNum, quantity: qty, properties: merged };
      if (sectionId) { body.sections = [sectionId]; body.sections_url = window.location.pathname; }
      return fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify(body)
      }).then(parseChangeResponse)
      .then(function(data){
        if (mainCartItems && sectionId && data && data.sections && data.sections[sectionId]) {
          var cartItems = document.querySelector('cart-items');
          if (cartItems && typeof cartItems.getSectionInnerHTML === 'function') {
            var jsContents = mainCartItems.querySelector('.js-contents') || mainCartItems;
            jsContents.innerHTML = cartItems.getSectionInnerHTML(data.sections[sectionId], '.js-contents');
          }
        }
        return data;
      });
    });
  }

  // ─── ITTF color rule ──────────────────────────────────────────────────────
  function checkIttfColors(fv, bv) {
    if (!fv || !bv) return null;
    function col(s) {
      var colorPart = s, emIdx = s.indexOf(' \u2014 ');
      if (emIdx !== -1) colorPart = s.substring(emIdx + 3);
      else {
        var parts = s.split(' - ');
        if (parts.length > 1) colorPart = parts[parts.length - 1];
      }
      var slashIdx = colorPart.indexOf(' / ');
      var color = slashIdx !== -1 ? colorPart.substring(0, slashIdx).trim() : colorPart.trim();
      color = color.replace(/[\d.]+mm$/i,'').trim();
      return color.toUpperCase();
    }
    var fc = col(fv), bc = col(bv);
    if (!fc || !bc) return null;
    if (fc === 'BLACK' && bc === 'BLACK') return 'both-black';
    if (fc !== 'BLACK' && bc !== 'BLACK') return {type:'neither-black', fc:fc, bc:bc};
    return 'valid';
  }

  // ─── Cross-panel exclusion ────────────────────────────────────────────────
  // Every panel (whether on the same blade line or a different one) counts as a
  // claim for 1 FH + 1 BH rubber. Rubber is unavailable in a panel's dropdown
  // if all cart copies of that rubber are already claimed by OTHER panels.
  function updateAllExclusions() {
    var panels = Array.from(document.querySelectorAll('.cw-ap__panel'));
    var cartQty = window._cwRubberQty || {};

    var claimedCount = {};
    panels.forEach(function(p) {
      var yesLabel = p.querySelector('.cw-ap__toggle-radios .cw-ap__tog:first-child');
      if (!yesLabel || !yesLabel.classList.contains('cw-ap__tog--active')) return;
      var fh = p.querySelector('.cw-ap__fh-sel'), bh = p.querySelector('.cw-ap__bh-sel');
      if (fh && fh.value && fh.value !== 'Unassembled')
        claimedCount[fh.value] = (claimedCount[fh.value] || 0) + 1;
      if (bh && bh.value && bh.value !== 'Unassembled')
        claimedCount[bh.value] = (claimedCount[bh.value] || 0) + 1;
    });

    panels.forEach(function(p) {
      var yesLabel = p.querySelector('.cw-ap__toggle-radios .cw-ap__tog:first-child');
      var myIsYes = yesLabel && yesLabel.classList.contains('cw-ap__tog--active');
      var fhSel = p.querySelector('.cw-ap__fh-sel'), bhSel = p.querySelector('.cw-ap__bh-sel');
      [fhSel, bhSel].forEach(function(sel) {
        if (!sel) return;
        var myVal = sel.value;
        Array.from(sel.options).forEach(function(opt) {
          if (!opt.value) return;
          var inCart = cartQty[opt.value] || 0;
          var claimed = claimedCount[opt.value] || 0;
          var myUse = (myIsYes && myVal === opt.value) ? 1 : 0;
          var takenByOther = (claimed - myUse) >= inCart;
          opt.disabled = takenByOther;
          opt.textContent = takenByOther ? opt.value + ' (assigned to another paddle)' : opt.value;
        });
      });
    });
  }

  // ─── Checkout validation ──────────────────────────────────────────────────
  function hookCheckout() {
    document.querySelectorAll('[name="checkout"]').forEach(function(btn) {
      if (btn.dataset.apHooked) return;
      btn.dataset.apHooked = '1';
      btn.addEventListener('click', function(e) {
        var incomplete = Array.from(document.querySelectorAll('.cw-ap__status-badge')).some(function(b) {
          return b.dataset.complete !== 'true';
        });
        if (!incomplete) return;
        e.preventDefault(); e.stopPropagation();
        document.querySelectorAll('.cw-ap__status-badge').forEach(function(b) {
          if (b.dataset.complete !== 'true') {
            var panel = b.closest('.cw-ap__panel');
            if (panel) { panel.style.outline='2px solid #dc2626'; setTimeout(function(){ panel.style.outline=''; },2500); }
          }
        });
        var wrap = document.getElementById('cw-assembly-prompt-wrap');
        if (wrap) wrap.scrollIntoView({behavior:'smooth'});
        alert('Please complete paddle assembly selections for all paddles before checking out.');
      });
    });
  }

  // ─── Cart row display updater ─────────────────────────────────────────────
  function updateBladeCartItemDOM(key, mergedProps) {
    var rows = document.querySelectorAll('tr[data-item-key], .page__cart-item');
    var bladeRow = null;
    rows.forEach(function(row) {
      if (row.dataset.itemKey === key || row.getAttribute('data-item-key') === key) bladeRow = row;
    });
    if (!bladeRow) return;
    var dl = bladeRow.querySelector('.cart-options');
    if (!dl) return;

    // Remove existing assembly entries (any of: legacy un-prefixed, old
    // "Paddle N X", or new "PN X" short format)
    var SHORT_SUFFIXES = Object.keys(SHORT_SUFFIX).map(function(k){ return SHORT_SUFFIX[k]; });
    function isOurLabel(lbl) {
      if (ASSEMBLY_KEYS.indexOf(lbl) !== -1) return true;
      var longMatch = lbl.match(/^Paddle \d+\s+(.+)$/);
      if (longMatch && ASSEMBLY_KEYS.indexOf(longMatch[1]) !== -1) return true;
      var shortMatch = lbl.match(/^P\d+\s+(.+)$/);
      if (shortMatch && SHORT_SUFFIXES.indexOf(shortMatch[1]) !== -1) return true;
      return false;
    }
    var toRemove = [];
    dl.querySelectorAll('.product-option').forEach(function(div) {
      var dt = div.querySelector('dt, span');
      if (!dt) return;
      var lbl = dt.textContent.trim().replace(':','');
      if (isOurLabel(lbl)) toRemove.push(div);
    });
    toRemove.forEach(function(el){ el.remove(); });

    // Sort new "PN suffix" short-format keys from merged props by slot, then
    // by the canonical ASSEMBLY_KEYS order (Assembly → FH → BH → Notes).
    function suffixToAssemblyKey(suffix) {
      for (var k in SHORT_SUFFIX) { if (SHORT_SUFFIX[k] === suffix) return k; }
      return null;
    }
    var displayKeys = Object.keys(mergedProps).filter(function(k) {
      var m = k.match(/^P(\d+)\s+(.+)$/);
      return m && SHORT_SUFFIXES.indexOf(m[2]) !== -1;
    }).sort(function(a, b) {
      var ma = a.match(/^P(\d+)\s+(.+)$/), mb = b.match(/^P(\d+)\s+(.+)$/);
      var slotA = parseInt(ma[1], 10), slotB = parseInt(mb[1], 10);
      if (slotA !== slotB) return slotA - slotB;
      var orderA = ASSEMBLY_KEYS.indexOf(suffixToAssemblyKey(ma[2]));
      var orderB = ASSEMBLY_KEYS.indexOf(suffixToAssemblyKey(mb[2]));
      return orderA - orderB;
    });

    displayKeys.forEach(function(propKey) {
      var val = mergedProps[propKey];
      if (!val || val === '') return;
      var div = document.createElement('div'); div.className = 'product-option inline-flex';
      var lbl = document.createElement('span'); lbl.textContent = propKey + ':'; lbl.style.marginLeft='4px';
      var val2 = document.createElement('span'); val2.textContent = val; val2.style.margin='0';
      div.appendChild(lbl); div.appendChild(val2);
      dl.appendChild(div);
    });
  }

  // ─── Build UI: one panel per paddle unit ──────────────────────────────────
  function buildUI(bladeItems, rubberItems) {
    var wrap = document.getElementById('cw-assembly-prompt-wrap');
    if (!wrap) return;
    wrap.innerHTML = '';
    if (!bladeItems.length || !rubberItems.length) return;

    var rubberLabelsInCart = {};
    rubberItems.forEach(function(r) {
      var lbl = rubberLabel(r);
      rubberLabelsInCart[lbl] = (rubberLabelsInCart[lbl] || 0) + (r.quantity || 1);
    });
    window._cwRubberQty = rubberLabelsInCart;

    var container = document.createElement('div');
    container.className = 'cw-ap__container';
    container.addEventListener('change', function(e){ e.stopPropagation(); });
    container.addEventListener('click', function(e){ e.stopPropagation(); });

    bladeItems.forEach(function(blade) {
      var bladeQty = parseInt(blade.quantity, 10) || 1;
      for (var s = 1; s <= bladeQty; s++) {
        (function(slotIndex) { buildSlotPanel(blade, slotIndex, bladeQty, rubberItems, rubberLabelsInCart, container); })(s);
      }
    });

    wrap.appendChild(container);
    updateAllExclusions();
    setTimeout(hookCheckout, 300);
  }

  // ─── Build one panel for one slot ─────────────────────────────────────────
  function buildSlotPanel(blade, slotIndex, bladeQty, rubberItems, rubberLabelsInCart, container) {
    var key = blade.key;
    var variantId = blade.variant_id;
    var savedAssemble = getSlotProp(blade, slotIndex, 'Assembly');
    var savedFH       = getSlotProp(blade, slotIndex, 'Forehand Rubber');
    var savedBH       = getSlotProp(blade, slotIndex, 'Backhand Rubber');
    var savedNote     = getSlotProp(blade, slotIndex, 'Assembly Notes');

    if (savedFH && !rubberLabelsInCart[savedFH]) savedFH = '';
    if (savedBH && !rubberLabelsInCart[savedBH]) savedBH = '';

    var choice = savedAssemble;
    var isComplete = (choice === 'No') || (choice === 'Yes' && (savedFH || savedBH));
    var shouldBeOpen = false;

    var panel = document.createElement('div');
    panel.className = 'cw-ap__panel';
    panel.dataset.bladeKey = key;
    panel.dataset.slotIndex = String(slotIndex);

    // Title: blade name + paddle slot indicator (only shown when qty > 1)
    var titleEl = document.createElement('div');
    titleEl.className = 'cw-ap__blade-title';
    var bladeName = (blade.title||'Blade') +
      (blade.variant_title && blade.variant_title!=='Default Title' ? ' \u2014 '+blade.variant_title : '');
    titleEl.textContent = bladeQty > 1 ? ('Paddle ' + slotIndex + ' of ' + bladeQty + ' \u00b7 ' + bladeName) : bladeName;
    panel.appendChild(titleEl);

    // Toggle bar
    var bar = document.createElement('div'); bar.className = 'cw-ap__toggle-bar';
    var lbl = document.createElement('span'); lbl.className = 'cw-ap__toggle-label'; lbl.textContent = 'Paddle Assembly'; bar.appendChild(lbl);
    var radWrap = document.createElement('div'); radWrap.className = 'cw-ap__toggle-radios';
    var yesBtn = document.createElement('label'); yesBtn.className = 'cw-ap__tog'+(choice==='Yes'?' cw-ap__tog--active':''); yesBtn.textContent = 'Yes';
    var noBtn  = document.createElement('label'); noBtn.className  = 'cw-ap__tog'+(choice==='No' ?' cw-ap__tog--active':''); noBtn.textContent  = 'No';
    radWrap.appendChild(yesBtn); radWrap.appendChild(noBtn); bar.appendChild(radWrap);
    var freeBadge = document.createElement('span'); freeBadge.className = 'cw-ap__free-badge'; freeBadge.textContent = 'Free Service'; bar.appendChild(freeBadge);
    var statusBadge = document.createElement('span');
    statusBadge.className = 'cw-ap__status-badge'+(isComplete?' cw-ap__status-badge--complete':' cw-ap__status-badge--required');
    statusBadge.dataset.complete = isComplete ? 'true' : 'false';
    statusBadge.textContent = isComplete ? '\u2713 Selection complete' : 'Selection required';
    bar.appendChild(statusBadge);
    panel.appendChild(bar);

    // Detail
    var detail = document.createElement('div'); detail.className = 'cw-ap__detail';
    detail.style.display = shouldBeOpen ? '' : 'none';

    function makeRow(sideCls, sideText, selCls, savedVal) {
      var row = document.createElement('div'); row.className = 'cw-ap__rubber-row';
      var side = document.createElement('span'); side.className = 'cw-ap__side '+sideCls; side.textContent = sideText; row.appendChild(side);
      var sel = document.createElement('select'); sel.className = selCls+' cw-ap__sel';
      var blank = document.createElement('option'); blank.value=''; blank.textContent='\u2014 Select rubber \u2014'; sel.appendChild(blank);
      rubberItems.forEach(function(r) {
        var rl = rubberLabel(r);
        var opt = document.createElement('option'); opt.value=rl; opt.textContent=rl;
        if (rl===savedVal) opt.selected=true;
        sel.appendChild(opt);
      });
      row.appendChild(sel);
      return row;
    }

    var grid = document.createElement('div'); grid.className = 'cw-ap__rubber-grid';
    var fhRow = makeRow('cw-ap__side--fh','FH','cw-ap__fh-sel',savedFH);
    var bhRow = makeRow('cw-ap__side--bh','BH','cw-ap__bh-sel',savedBH);
    var fhSel = fhRow.querySelector('select');
    var bhSel = bhRow.querySelector('select');
    grid.appendChild(fhRow); grid.appendChild(bhRow); detail.appendChild(grid);

    var warnWrap = document.createElement('div'); warnWrap.className='cw-ap__warn-wrap'; detail.appendChild(warnWrap);

    var noteEl = document.createElement('textarea');
    noteEl.className='cw-ap__note'; noteEl.maxLength=200; noteEl.rows=1;
    noteEl.placeholder='Special instructions (optional)'; noteEl.value=savedNote;
    var noteRow = document.createElement('div'); noteRow.className='cw-ap__note-row'; noteRow.appendChild(noteEl); detail.appendChild(noteRow);

    var saveBtn = document.createElement('button'); saveBtn.type='button'; saveBtn.className='cw-ap__save'; saveBtn.textContent='Save assembly details';
    var statusEl = document.createElement('span'); statusEl.className='cw-ap__status';
    var actRow = document.createElement('div'); actRow.className='cw-ap__action-row'; actRow.appendChild(saveBtn); actRow.appendChild(statusEl);
    detail.appendChild(actRow);
    panel.appendChild(detail);
    container.appendChild(panel);

    // ── Events ──
    function setStatus(msg, type) {
      statusEl.textContent=msg;
      statusEl.className='cw-ap__status'+(type?' cw-ap__status--'+type:'');
    }

    function checkWarnings() {
      warnWrap.innerHTML = '';
      var fv=fhSel.value, bv=bhSel.value;
      if (!fv || !bv) return;
      function warn(msg, cls) {
        var w=document.createElement('p');
        w.className='cw-ap__warn'+(cls?' '+cls:'');
        w.textContent=msg;
        warnWrap.appendChild(w);
      }
      if (fv===bv) warn('\u26a0\ufe0f Same rubber on both sides \u2014 intentional?');
      var ittf = checkIttfColors(fv, bv);
      if (ittf === 'both-black') warn('\u26a0\ufe0f Not ITTF legal: both rubbers are black. One must be a different color.','cw-ap__warn--ittf');
      else if (ittf && ittf.type === 'neither-black') warn('\u26a0\ufe0f Not ITTF legal: neither rubber is black (FH: '+ittf.fc+', BH: '+ittf.bc+'). One must be black.','cw-ap__warn--ittf');
    }

    function setChoice(v) {
      choice = v;
      yesBtn.classList.toggle('cw-ap__tog--active', v==='Yes');
      noBtn.classList.toggle('cw-ap__tog--active', v==='No');
      detail.style.display = v==='Yes' ? '' : 'none';
      if (v==='Yes') {
        checkWarnings();
        // Switching to Yes makes any prior saved answer (e.g. a stale "No")
        // provisional. Optimistically mark the slot incomplete; the debounced
        // committer then either clears the stale answer (no rubber picked yet)
        // or persists the real Yes (rubber picked). Prevents an in-progress Yes
        // from shipping as the old No.
        statusBadge.dataset.complete='false';
        statusBadge.className='cw-ap__status-badge cw-ap__status-badge--required';
        statusBadge.textContent='Selection required';
        scheduleAutoSave();
      }
    }

    yesBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      if (choice==='Yes' && detail.style.display==='none') detail.style.display='';
      else setChoice('Yes');
    });

    noBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      setChoice('No');
      saveBtn.disabled=true; setStatus('Saving\u2026','');
      var update = {'Assembly':'No','Forehand Rubber':'','Backhand Rubber':'','Assembly Notes':''};
      saveSlotProps(variantId, slotIndex, update)
        .then(function(result){
          setStatus('\u2713 Saved','ok');
          statusBadge.dataset.complete='true';
          statusBadge.className='cw-ap__status-badge cw-ap__status-badge--complete';
          statusBadge.textContent='\u2713 Selection complete';
          updateBladeCartItemDOM(key, result.merged);
          updateAllExclusions();
          setTimeout(function(){ setStatus('',''); },2000);
        })
        .catch(function(){ setStatus('Error \u2014 try again','error'); })
        .finally(function(){ saveBtn.disabled=false; });
    });

    // Auto-save the Yes side as soon as rubbers are picked, so the customer
    // never has to click "Save assembly details" for it to persist (mirrors the
    // No button's save-on-click). Also the single writer for the in-progress
    // Yes-with-no-rubber case: it clears any stale saved answer and keeps the
    // slot incomplete. Debounced, so it is the only thing that writes the Yes
    // side -> no races between the clear and the real save.
    function autoSaveYes() {
      if (choice !== 'Yes') return;
      var fv = fhSel.value.trim(), bv = bhSel.value.trim();
      if (fv && !rubberLabelsInCart[fv]) return;
      if (bv && !rubberLabelsInCart[bv]) return;
      var willComplete = !!(fv || bv);
      var update = willComplete
        ? { 'Assembly':'Yes',
            'Forehand Rubber': fv || 'Unassembled',
            'Backhand Rubber': bv || 'Unassembled',
            'Assembly Notes': noteEl.value.trim() || '' }
        : { 'Assembly':'', 'Forehand Rubber':'', 'Backhand Rubber':'', 'Assembly Notes':'' };
      saveBtn.disabled=true; setStatus('Saving\u2026','');
      saveSlotProps(variantId, slotIndex, update)
        .then(function(result){
          if (willComplete) {
            setStatus('\u2713 Saved','ok');
            statusBadge.dataset.complete='true';
            statusBadge.className='cw-ap__status-badge cw-ap__status-badge--complete';
            statusBadge.textContent='\u2713 Selection complete';
            setTimeout(function(){ setStatus('',''); },2000);
          } else {
            setStatus('','');
            statusBadge.dataset.complete='false';
            statusBadge.className='cw-ap__status-badge cw-ap__status-badge--required';
            statusBadge.textContent='Selection required';
          }
          updateBladeCartItemDOM(key, result.merged);
          updateAllExclusions();
        })
        .catch(function(){ setStatus('Error \u2014 try again','error'); })
        .finally(function(){ saveBtn.disabled=false; });
    }
    var _cwAutoSaveTimer;
    function scheduleAutoSave(){ clearTimeout(_cwAutoSaveTimer); _cwAutoSaveTimer=setTimeout(autoSaveYes,400); }

    fhSel.addEventListener('change', function(e){ e.stopPropagation(); checkWarnings(); setStatus('',''); updateAllExclusions(); scheduleAutoSave(); });
    bhSel.addEventListener('change', function(e){ e.stopPropagation(); checkWarnings(); setStatus('',''); updateAllExclusions(); scheduleAutoSave(); });
    noteEl.addEventListener('input',  function(e){ e.stopPropagation(); noteEl.style.height='auto'; noteEl.style.height=noteEl.scrollHeight+'px'; });
    noteEl.addEventListener('change', function(e){ e.stopPropagation(); scheduleAutoSave(); });

    saveBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      if (!choice) { setStatus('Select Yes or No','error'); return; }
      var update = {'Assembly': choice};
      if (choice==='Yes') {
        var fv=fhSel.value.trim(), bv=bhSel.value.trim();
        if (!fv && !bv) { setStatus('Select at least one rubber','error'); return; }
        if (fv && !rubberLabelsInCart[fv]) { setStatus('Forehand rubber no longer in cart','error'); return; }
        if (bv && !rubberLabelsInCart[bv]) { setStatus('Backhand rubber no longer in cart','error'); return; }
        if (fv && bv && fv === bv) {
          var qty = rubberLabelsInCart[fv] || 0;
          if (qty < 2) { setStatus('Need 2 of this rubber to use on both sides','error'); return; }
        }
        // Cross-panel conflict — skip only THIS exact panel (same blade AND same slot)
        var claimedCount = {};
        document.querySelectorAll('.cw-ap__panel').forEach(function(p){
          if (p.dataset.bladeKey === key && parseInt(p.dataset.slotIndex, 10) === slotIndex) return;
          var pYes = p.querySelector('.cw-ap__toggle-radios .cw-ap__tog:first-child');
          if (!pYes || !pYes.classList.contains('cw-ap__tog--active')) return;
          var pFh = p.querySelector('.cw-ap__fh-sel'), pBh = p.querySelector('.cw-ap__bh-sel');
          if (pFh && pFh.value && pFh.value !== 'Unassembled')
            claimedCount[pFh.value] = (claimedCount[pFh.value] || 0) + 1;
          if (pBh && pBh.value && pBh.value !== 'Unassembled')
            claimedCount[pBh.value] = (claimedCount[pBh.value] || 0) + 1;
        });
        var cartQty = window._cwRubberQty || {};
        var conflictFv = fv && (claimedCount[fv] || 0) >= (cartQty[fv] || 0);
        var conflictBv = bv && bv !== fv && (claimedCount[bv] || 0) >= (cartQty[bv] || 0);
        if (conflictFv || conflictBv) { setStatus('Rubber already assigned to another paddle','error'); return; }
        update['Forehand Rubber'] = fv || 'Unassembled';
        update['Backhand Rubber'] = bv || 'Unassembled';
        var nv=noteEl.value.trim(); update['Assembly Notes'] = nv || '';
      } else {
        update['Forehand Rubber']=''; update['Backhand Rubber']=''; update['Assembly Notes']='';
      }
      saveBtn.disabled=true; setStatus('Saving\u2026','');
      saveSlotProps(variantId, slotIndex, update)
        .then(function(result){
          setStatus('\u2713 Saved','ok');
          statusBadge.dataset.complete='true';
          statusBadge.className='cw-ap__status-badge cw-ap__status-badge--complete';
          statusBadge.textContent='\u2713 Selection complete';
          if(choice==='Yes') detail.style.display='none';
          updateBladeCartItemDOM(key, result.merged);
          updateAllExclusions();
          setTimeout(function(){ setStatus('',''); },2000);
        })
        .catch(function(err){
          console.error('[Assembly]',err);
          setStatus('Error \u2014 try again','error');
        })
        .finally(function(){ saveBtn.disabled=false; });
    });

    if (choice==='Yes' && savedFH && savedBH) checkWarnings();
  }

  // ─── Init: cleanup stale rubbers + build UI ───────────────────────────────
  function init() {
    fetchCart().then(function(cart){
      var items = cart.items || [];
      var blades  = items.filter(function(i){ return isBladeType(i.product_type) && !isComboChild(i); });
      var rubbers = items.filter(function(i){ return isRubberType(i.product_type) && !isComboChild(i); });

      var rubberLabelsInCart = {};
      rubbers.forEach(function(r) { rubberLabelsInCart[rubberLabel(r)] = true; });

      // Cleanup pass: for each blade line, detect two kinds of dirty state:
      //   (1) stale rubber references (saved rubber no longer in cart)
      //   (2) orphaned slot properties (slots beyond current blade quantity,
      //       left behind when customer lowered the quantity)
      // Queue saves to fix; the last one re-renders the cart section so the
      // displayed line item reflects the cleaned properties.
      var cleanupActions = [];
      blades.forEach(function(blade) {
        var bladeQty = parseInt(blade.quantity, 10) || 1;

        // Detect orphan slots in the raw blade.properties
        var cp = blade.properties || {};
        var propKeys = Array.isArray(cp)
          ? cp.map(function(p){ return p.name; })
          : Object.keys(cp);
        var hasOrphanSlot = propKeys.some(function(k){
          var m = k.match(/^(?:P|Paddle )(\d+)\s+/);
          return m && parseInt(m[1], 10) > bladeQty;
        });

        // Detect stale rubber refs per active slot
        var hasStaleRubber = false;
        for (var s = 1; s <= bladeQty; s++) {
          var fh = getSlotProp(blade, s, 'Forehand Rubber');
          var bh = getSlotProp(blade, s, 'Backhand Rubber');
          var fhStale = fh && !rubberLabelsInCart[fh];
          var bhStale = bh && !rubberLabelsInCart[bh];
          if (!fhStale && !bhStale) continue;
          hasStaleRubber = true;
          cleanupActions.push({
            bladeVariantId: blade.variant_id,
            slotIndex: s,
            update: {
              'Forehand Rubber': fhStale ? '' : (fh || ''),
              'Backhand Rubber': bhStale ? '' : (bh || '')
            }
          });
        }

        // If only orphan slots (no stale rubbers), queue a no-op save on slot 1.
        // The update is empty; buildMergedProps still strips orphan keys during
        // the merge, so the saved line ends up without them.
        if (hasOrphanSlot && !hasStaleRubber) {
          cleanupActions.push({
            bladeVariantId: blade.variant_id,
            slotIndex: 1,
            update: {}
          });
        }
      });

      if (cleanupActions.length > 0) {
        var chain = Promise.resolve();
        cleanupActions.forEach(function(action, idx) {
          var isLast = idx === cleanupActions.length - 1;
          chain = chain.then(function() {
            return isLast
              ? saveSlotPropsAndRerender(action.bladeVariantId, action.slotIndex, action.update)
              : saveSlotProps(action.bladeVariantId, action.slotIndex, action.update);
          });
        });
        chain.catch(function(e){ console.warn('[Assembly cleanup]', e); });
        return; // MutationObserver retriggers init() once re-render swaps in
      }

      buildUI(blades, rubbers);
    }).catch(function(e){ console.warn('[Assembly]',e); });
  }

  function tryInit() {
    var wrap = document.getElementById('cw-assembly-prompt-wrap');
    if (!wrap) return;
    init();
  }

  document.addEventListener('DOMContentLoaded', tryInit);

  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      clearTimeout(window._cwApTimer);
      window._cwApTimer = setTimeout(tryInit, 300);
    }
  });

  document.addEventListener('DOMContentLoaded', function(){
    var jsContents = document.querySelector('#main-cart-items .js-contents');
    if (!jsContents) return;
    new MutationObserver(function(){
      clearTimeout(window._cwApTimer);
      window._cwApTimer = setTimeout(init, 800);
    }).observe(jsContents, {childList:true, subtree:false});
  });

})();
